import React from 'react';

const SortIndicator = ({ sortConfig, columnKey }) => {
  if (sortConfig.key !== columnKey) {
    return <span className="ml-1 text-gray-400">↕</span>;
  }
  
  return (
    <span className="ml-1">
      {sortConfig.direction === 'asc' ? '↑' : '↓'}
    </span>
  );
};

export default SortIndicator;